import React, { useEffect, useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { apiCall, mediaUrl } from "../util";
import axios from "axios";
import {
  gokulam_logo_icon,
  our_doctors,
  anesthesia,
  cardiology,
  neurology,
  obstetrics,
  urology,
} from "../Image";
import { Link } from "react-router-dom";
const OurDoctors = () => {
  const [titleData, setTitleData] = useState(null);
  const [departments, setDepartment] = useState([]);
  useEffect(() => {
    const fetchDoctorTitle = async () => {
      try {
        const response = await axios.post(apiCall + "doctortitle/getall");
        if (response.data && response.data[0]) {
          setTitleData(response.data[0]);
        }
      } catch (error) {
        console.error("Error fetching doctor title:", error);
      }
    };
    fetchDoctorTitle();
  }, []);
  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await axios.get(apiCall + "department/getall");
        setDepartment(response.data.slice(0, 12));
        // console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchDepartment();
  }, []); 

  return (
    <section className="-overflow-hidden half-section bg-white position-relative">
      <img
        src={gokulam_logo_icon}
        alt="gokulam logo"
        className="animated-logo-5 float"
      />
      <div className="container position-relative z-3">
        <div className="row">
          {/* Left section with animation */}
          <div className="col-12 col-xl-4 col-lg-7 col-md-8 order-1 position-relative">
            <ScrollAnimation
              animateIn="animate__fadeInLeft"
              animateOnce={true} // Ensures the animation triggers only once
              duration={1.2}
            >
              <div className="d-flex align-items-end gap-2">
                <img src={our_doctors} className="h-60px" alt="" />
                <div>
                  <span className="text-base-color fw-600 -mb-5px text-uppercase d-block fs-12">
                    Hospital
                  </span>
                  <h5 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
                    Our{" "}
                    <span className="text-gradient-sg-red-purple">Doctors</span>
                  </h5>
                </div>
              </div>
              <p className="text-black mt-3">
                {titleData?.title
                  ? titleData.title
                  : "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut dolores ipsum sint alias iste adipisci."}
              </p>
            </ScrollAnimation>
          </div>

          {/* Right section with department cards */}
          <div className="col-xl-8 col-lg-12 order-2 order-md-3">
            <ScrollAnimation
              animateIn="animate__fadeInUp"
              animateOnce={true}
              duration={1}
            >
              <div className="row gy-4">
                {departments.map((dept, index) => (
                  <div key={index} className="col-6 col-md-3">
                    <ScrollAnimation
                      animateIn="animate__zoomIn"
                      delay={index * 100}
                      animateOnce={true}
                      className="h-100"
                    >
                      <div className="dept_card bg-white rounded-4 d-flex align-items-center justify-content-center h-100">
                        <Link
                          to={`/department/${dept.slug}`}
                          state={{ departmentId: dept.id }}
                        >
                          <img
                            className="h-40px"
                            src={`${mediaUrl}/${dept?.icon}`}
                            alt={dept.name}
                          />
                          <h5 className="alt-font fw-500 fs-16 m-0 mt-10px mb-10px text-dark">
                            {dept.name}
                          </h5>
                          <span className="bg-base-color">
                            <i className="bi bi-arrow-up-right text-white"></i>
                          </span>
                        </Link>
                      </div>
                    </ScrollAnimation>
                  </div>
                ))}
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurDoctors;

